import { z } from 'zod'

export const csChatSessionResponseSchema = z.object({
  session_token: z.string().min(1),
  bot_id: z.string().min(1),
  host: z.string().min(1),
  name: z.string().min(1),
  phone: z.string().min(1),
})

export type CsChatSessionResponse = z.infer<typeof csChatSessionResponseSchema>
